import {CSSProperties, FC} from 'react';


export interface IIconCarFrontBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconCarFrontBmw: FC<IIconCarFrontBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="M19.111 12.222v.445c0 .736-.375 1.333-1.111 1.333h-2v-.444c0-.736.597-1.334 1.333-1.334h1.778ZM14 14h-1.333c-.246 0-.667-.199-.667-.444v-.89c0-.245.42-.444.667-.444h2.044c.267 0 .622.178.622.445C15.333 13.556 14.56 14 14 14ZM7.111 9.556c.507-1.39 1.097-2.667 2.489-2.667h4.8c1.392 0 1.982 1.278 2.489 2.667H7.11Zm4.889 4c0 .245-.42.444-.667.444H10c-.56 0-1.333-.444-1.333-1.333 0-.267.355-.445.622-.445h2.044c.246 0 .667.199.667.445v.889ZM8 14H6c-.736 0-1.556-.597-1.556-1.333v-.445h2.223c.736 0 1.333.598 1.333 1.334V14Zm11.556-4.211c.381-.115.444-.345.444-.611s-.18-.511-.533-.511h-1.69C16.623 6.889 16 6 14.134 6H9.867C8 6 7.377 6.889 6.222 8.667H4.533c-.353 0-.533.245-.533.51 0 .267.063.497.444.612l1.245.261L4 11.333v5.778c0 .491.398.889.889.889h1.333c.49 0 .89-.398.89-.889v-.444H16.888v.444c0 .491.398.889.889.889h1.333c.49 0 .889-.398.889-.889v-5.778l-1.689-1.283 1.245-.261Z" clipRule="evenodd" />
        </svg>
    );
};
